import React from 'react';

class MarketingErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Marketing render error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, background: '#fff3f3', color: '#8b0000', border: '1px solid #f1b5b5', margin: 16, borderRadius: 12 }}>
          <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>Marketing module render error</div>
          <div style={{ fontSize: 14, whiteSpace: 'pre-wrap' }}>
            {this.state.error?.message || 'Unknown render error'}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default MarketingErrorBoundary;

